import { createStore, combineReducers, applyMiddleware } from 'redux'
import { agentMiddleware } from '@advisiondevelopment/redux/middleware'
import thunk from 'redux-thunk'

import agents from 'agents'
import * as reducers from 'reducers'

const configureStore = (environment) => {
  const { endpoint, siteDomain } = environment

  agents.init(siteDomain, endpoint)
  const rootReducer = combineReducers(reducers)
  const middlewares = [thunk, agentMiddleware(agents)]

  return createStore(rootReducer, {}, applyMiddleware(...middlewares))
}

export default configureStore
